<nz-modal
	[(nzVisible)]="deleteModal"
	(nzOnCancel)="deleteModal = false"
	(nzOnOk)="onDelete()"
	[nzTitle]="'common_deletion' | translate"
	[nzContent]="'common_delete-one' | translate"
	[nzOkLoading]="deleting"
></nz-modal>
<form
	nz-form
	class="role-form w-100"
	*ngIf="form"
	[formGroup]="form"
	(ngSubmit)="onSubmit()"
	[nzAutoTips]="explainErrorsService.autoTips"
>
	<nz-affix>
		<div class="py-4 border-bottom bg-white">
			<div class="container">
				<div class="row">
					<div
						class="col-12 d-flex align-items-center justify-content-between"
					>
						<!-- Title -->
						<div>
							<h1 class="mb-0">
								<span *ngIf="role.isNew()">{{
									'role_create-form-title' | translate
								}}</span>
								<span *ngIf="!role.isNew()">{{
									role.getLabel()
								}}</span>
							</h1>
							<small
								*ngIf="!role.isNew()"
								class="text-black-50"
								>{{
									'common_id'
										| translate: { id: role.getId() }
								}}</small
							>
						</div>
						<!-- /Title -->

						<!-- Actions -->
						<div>
							<button
								nz-button
								[disabled]="form.invalid"
								[nzLoading]="saving"
								nzType="primary"
								*appRestrictedByScope="{
									model: 'role',
									action: 'update'
								}"
							>
								{{ 'common_save' | translate }}
							</button>
							<ng-container
								*appRestrictedByScope="{
									model: 'role',
									action: 'delete'
								}"
							>
								<button
									*ngIf="!role.isNew() && deletable"
									class="ml-4"
									nz-button
									nzShape="circle"
									[title]="'common_delete' | translate"
									[nzLoading]="deleting"
									(click)="deleteModal = true"
									type="button"
								>
									<i nz-icon nzType="delete"></i>
								</button>
							</ng-container>
						</div>
						<!-- /Actions -->
					</div>
				</div>
			</div>
		</div>
	</nz-affix>
	<div class="container">
		<nz-card class="round-border my-5">
			<div *ngIf="loading" class="row">
				<div class="col-12">
					<nz-skeleton
						class="no-header"
						[nzActive]="true"
					></nz-skeleton>
				</div>
			</div>
			<div *ngIf="!loading">
				<div class="row" *ngIf="!readOnly">
					<div class="col-12 col-md-6">
						<!-- Name -->
						<nz-form-item>
							<h4>{{ 'role_name' | translate }}</h4>
							<nz-form-control>
								<input
									nz-input
									class="w-100"
									type="text"
									[placeholder]="
										'common_value-string' | translate
									"
									formControlName="name"
								/>
							</nz-form-control>
						</nz-form-item>
						<!-- /Name -->
					</div>
				</div>

				<nz-divider *ngIf="!role.isNew() && !readOnly"></nz-divider>
				<div *ngIf="!role.isNew()" class="row">
					<div class="col-12 col-md-6">
						<!-- _Id -->
						<div class="mb-4">
							<h4>{{ 'role_-id' | translate }}</h4>
							<div>{{ role.props._id }}</div>
						</div>
						<!-- /_Id -->
					</div>
					<div class="col-12 col-md-6">
						<!-- Created At -->
						<div class="mb-4">
							<h4>{{ 'role_created-at' | translate }}</h4>
							<div>
								{{ role.props.created_at | date: 'medium' }}
							</div>
						</div>
						<!-- /Created At -->
					</div>
					<div class="col-12 col-md-6" *ngIf="readOnly">
						<!-- Name -->
						<div class="mb-4">
							<h4>{{ 'role_name' | translate }}</h4>
							<div>{{ role.props.name }}</div>
						</div>
						<!-- /Name -->
					</div>
					<div class="col-12 col-md-6">
						<!-- Admin -->
						<div class="mb-4">
							<h4>{{ 'role_admin' | translate }}</h4>
							<div>
								<span
									*ngIf="
										role.props.admin === true ||
										role.props.admin === false
									"
								>
									{{
										(role.props.admin
											? 'common_true'
											: 'common_false'
										) | translate
									}}
								</span>
							</div>
						</div>
						<!-- /Admin -->
					</div>
				</div>
			</div>
		</nz-card>
	</div>
</form>
